const slides = {
  addSlide: "Добавить слайд",
  deleteSlide: "Удалить слайд",
  duplicateSlide: "Дублировать слайд",
  addText: "Добавить текст",
  addImage: "Добавить изображение",
  addShape: "Добавить фигуру",
  present: "Показ",
  exitPresentation: "Выйти из презентации",
  slideOf: "Слайд {current} из {total}",
  fontFamily: "Шрифт",
  fontSize: "Размер шрифта",
  fillColor: "Цвет заливки",
  borderColor: "Цвет границы",
  bringForward: "Переместить вперёд",
  sendBackward: "Переместить назад",
  deleteElement: "Удалить элемент",
  rectangle: "Прямоугольник",
  circle: "Круг",
  arrow: "Стрелка",
  line: "Линия",
  untitled: "Без названия",
} as const;
export default slides;
